"use client";

import { c as _c } from "react/compiler-runtime";
import type { BillingGateStatusResponse } from "@/contexts/billing/core/presentation/rpc/billing-lockout-rpc";
import type { BillingBannerRegion } from "@/entities/billing/model/billing-banner-region";
import { SoftLockBanner } from "./soft-lock-banner";
import { HardLockBanner } from "./hard-lock-banner";
import { OutstandingInvoicesBanner } from "./outstanding-invoices-banner";
import { CopayFailureNotice } from "./copay-failure-notice";
import { PaymentMethodSetupBanner } from "./payment-method-setup-banner";
import { PaymentProcessingBanner } from "./payment-processing-banner";
interface BillingGateBannersProps {
  readonly region: BillingBannerRegion;
  readonly gateStatus: BillingGateStatusResponse;
  /** `identity.isAdmin` (includes super-admins), never `gateStatus.isAdmin`. */
  readonly isAdmin: boolean;
}

/** The banners of one region `BillingGate` puts above the app (`billingBannerRegionOf`). */
export function BillingGateBanners(t0) {
  const $ = _c(36);
  const {
    region,
    gateStatus,
    isAdmin
  } = t0;
  if (region.kind === "hard-lock" || region.kind === "soft-lock") {
    let t1;
    if ($[0] !== gateStatus.allowMissionCritical || $[1] !== gateStatus.amountDueCents || $[2] !== gateStatus.attemptCount || $[3] !== gateStatus.billingAdminEmail || $[4] !== gateStatus.billingAdminName || $[5] !== gateStatus.currency || $[6] !== gateStatus.isAdmin || $[7] !== gateStatus.lastFailureDate || $[8] !== gateStatus.nextRetryDate || $[9] !== gateStatus.paymentMethodBrand || $[10] !== gateStatus.paymentMethodLast4 || $[11] !== gateStatus.phase || $[12] !== gateStatus.stripeInvoiceId) {
      t1 = {
        phase: gateStatus.phase,
        allowMissionCritical: gateStatus.allowMissionCritical,
        billingAdminName: gateStatus.billingAdminName,
        billingAdminEmail: gateStatus.billingAdminEmail,
        attemptCount: gateStatus.attemptCount,
        lastFailureDate: gateStatus.lastFailureDate,
        nextRetryDate: gateStatus.nextRetryDate,
        isAdmin: gateStatus.isAdmin,
        amountDueCents: gateStatus.amountDueCents,
        currency: gateStatus.currency,
        stripeInvoiceId: gateStatus.stripeInvoiceId,
        paymentMethodLast4: gateStatus.paymentMethodLast4,
        paymentMethodBrand: gateStatus.paymentMethodBrand
      };
      $[0] = gateStatus.allowMissionCritical;
      $[1] = gateStatus.amountDueCents;
      $[2] = gateStatus.attemptCount;
      $[3] = gateStatus.billingAdminEmail;
      $[4] = gateStatus.billingAdminName;
      $[5] = gateStatus.currency;
      $[6] = gateStatus.isAdmin;
      $[7] = gateStatus.lastFailureDate;
      $[8] = gateStatus.nextRetryDate;
      $[9] = gateStatus.paymentMethodBrand;
      $[10] = gateStatus.paymentMethodLast4;
      $[11] = gateStatus.phase;
      $[12] = gateStatus.stripeInvoiceId;
      $[13] = t1;
    } else {
      t1 = $[13];
    }
    const lockoutStatus = t1;
    let t2;
    if ($[14] !== lockoutStatus || $[15] !== region.kind) {
      t2 = region.kind === "hard-lock" ? <HardLockBanner lockoutStatus={lockoutStatus} /> : <SoftLockBanner lockoutStatus={lockoutStatus} />;
      $[14] = lockoutStatus;
      $[15] = region.kind;
      $[16] = t2;
    } else {
      t2 = $[16];
    }
    return t2;
  }
  let t1;
  if ($[17] !== gateStatus || $[18] !== isAdmin || $[19] !== region.paymentMethodSetup) {
    t1 = region.paymentMethodSetup ? <PaymentMethodSetupBanner renewalAt={gateStatus.paymentMethodRenewalAt} isAdmin={isAdmin} billingAdminName={gateStatus.billingAdminName} /> : null;
    $[17] = gateStatus;
    $[18] = isAdmin;
    $[19] = region.paymentMethodSetup;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  let t2;
  if ($[21] !== gateStatus || $[22] !== isAdmin || $[23] !== region.copay) {
    t2 = region.copay ? <CopayFailureNotice isAdmin={isAdmin} failure={gateStatus.copayFailure ?? null} /> : null;
    $[21] = gateStatus;
    $[22] = isAdmin;
    $[23] = region.copay;
    $[24] = t2;
  } else {
    t2 = $[24];
  }
  let t3;
  if ($[25] !== gateStatus || $[26] !== isAdmin || $[27] !== region.outstanding) {
    t3 = region.outstanding ? <OutstandingInvoicesBanner isAdmin={isAdmin} outstandingInvoiceCount={gateStatus.outstandingInvoiceCount} outstandingTotalCents={gateStatus.outstandingTotalCents} outstandingCurrency={gateStatus.outstandingCurrency} oldestUnpaidDueAt={gateStatus.oldestUnpaidDueAt} payByCardAvailable={gateStatus.payByCardAvailable} /> : null;
    $[25] = gateStatus;
    $[26] = isAdmin;
    $[27] = region.outstanding;
    $[28] = t3;
  } else {
    t3 = $[28];
  }
  let t4;
  if ($[29] !== region.processing) {
    t4 = region.processing ? <PaymentProcessingBanner /> : null;
    $[29] = region.processing;
    $[30] = t4;
  } else {
    t4 = $[30];
  }
  let t5;
  if ($[31] !== t1 || $[32] !== t2 || $[33] !== t3 || $[34] !== t4) {
    t5 = <>{t1}{t2}{t3}{t4}</>;
    $[31] = t1;
    $[32] = t2;
    $[33] = t3;
    $[34] = t4;
    $[35] = t5;
  } else {
    t5 = $[35];
  }
  return t5;
}